
import { Container, Typography } from "@mui/material";
import React from "react";
import LegalFAQ from "./LegalFAQ";

export default function LegalFAQView() {

  return (
    <Container id ='legalFAQ'sx={{padding:'20px 0px'}}>
        <Typography variant= 'h2' sx={{padding:'20px 0px'}}>Common Legal Issues Q&A</Typography>
      <LegalFAQ />
    </Container>
  );
}
